import React from "react";
import { links } from "../data/Link";

const Footer: React.FC = () => {
  return (
    <footer className="py-12 border-t bg-slate-900/80 border-slate-700">
      <div className="max-w-6xl px-6 mx-auto text-center">
        <div className="mb-4 text-xl font-bold text-transparent bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text">
          Silvintage
        </div>
        <p className="max-w-2xl mx-auto mb-8 text-slate-400">
          Delivering thoughtful design solutions that inspire and engage.
        </p>

        <div className="flex justify-center gap-6 mb-8">
          {links.map(({ label, icon, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors text-slate-400 hover:text-cyan-400"
              title={label}
            >
              {icon}
            </a>
          ))}
        </div>

        <div className="text-sm text-slate-500">
          © {new Date().getFullYear()} Silvintage. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
